define('model/ClientTermsModel',['require','lib/model/BaseModel','lib/validator/ValidatorNotEmpty','lib/terms/TermsAndConditions'],function (require) {

    var BaseModel = require('lib/model/BaseModel');
    var ValidatorNotEmpty = require('lib/validator/ValidatorNotEmpty');
    var TermsAndConditions = require('lib/terms/TermsAndConditions');

    /**
     * Client accepted terms info model
     *
     * @class ClientTermsModel
     */
    return BaseModel.extend({

        url: '/client/terms',
        _termsAndConditions: null,

        defaults: {
            id: null,
            simplybook_terms: null,
            user_terms: null,
            cancellation_terms: null,
            promotion_letters: null,
            simplybook_terms_flag: null,
            user_terms_flag: null,
            cancellation_terms_flag: null,
            promotion_letters_flag: null,
            privacy_policy: null,
            privacy_policy_flag: null
        },

        getValidators: function () {
            var terms = this.getTermsAndConditions();

            var validators = {};
            if (terms.isSimplybookTermsAndConditionsVisible()) {
                validators['simplybook_terms_flag'] = [new ValidatorNotEmpty()];
            }
            if (terms.isUserTermsAndConditionsVisible()) {
                validators['user_terms_flag'] = [new ValidatorNotEmpty()];
            }
            if (terms.isPrivacyPolicyVisible()) {
                validators['privacy_policy_flag'] = [new ValidatorNotEmpty()];
            }
            if (terms.isCancellationPolicyVisible()) {
                validators['cancellation_terms_flag'] = [new ValidatorNotEmpty()];
            }
            return validators;
        },

        getTermsAndConditions: function () {
            if (!this._termsAndConditions) {
                this._termsAndConditions = new TermsAndConditions({
                    clientTermsModel: this
                });
            }
            return this._termsAndConditions;
        },

        getAcceptedTerms: function () {
            return {
                simplybook_terms: this.get('simplybook_terms_flag') || this.get('simplybook_terms'),
                user_terms: this.get('user_terms_flag') || this.get('user_terms'),
                privacy_policy: this.get('privacy_policy_flag') || this.get('privacy_policy'),
                cancellation_terms: this.get('cancellation_terms_flag') || this.get('cancellation_terms'),
                promotion_letters: this.get('promotion_letters_flag') || this.get('promotion_letters')
            };
        },

        getAcceptedTermsWithoutPromoFlags: function () {
            var acceptedPromoTerms = this.get('promotion_letters');
            return _.extend(this.getAcceptedTerms(), {
                promotion_letters: acceptedPromoTerms === null? true : acceptedPromoTerms
            });
        },

        fetch: function () {
            this.set(this.defaults, {silent: true});

            return BaseModel.prototype.fetch.apply(this, arguments);
        }

    });

});
